// extracted by mini-css-extract-plugin
export default {"custom-checkbox":"CheckBox_custom-checkbox__+axtJ","customCheckbox":"CheckBox_custom-checkbox__+axtJ"};